// How deep to search before giving up. To prevent infinite loops.
const MAX_DEPTH = 100;

/**
 * Returns true if the target element is within the parent element.
 */
export function isWithinElement(
  targetElement: HTMLElement | null | undefined,
  parentElement: HTMLElement | null | undefined,
) {
  if (parentElement == null) {
    return false;
  }

  let depth = 0;
  let isWithin = false;
  let current = targetElement;
  while (!isWithin && current != null && depth < MAX_DEPTH) {
    if (current === parentElement) {
      isWithin = true;
      break;
    }
    // In case of a dialog, it is rendered in a portal, so we need to find the button that opened it.
    if (current.role === "dialog") {
      const id = current.id;
      current = document.querySelector(`[aria-controls="${id}"]`) as HTMLElement | null;
    }
    current = current?.parentElement;
    depth += 1;
  }
  return isWithin;
}
